import React from "react";
import { Link } from "react-router-dom";
import { SEO } from "@/components/common/SEO";

export default function NotFoundPage() {
  return (
    <div className="mx-auto flex min-h-[60vh] max-w-2xl flex-col items-center justify-center px-4 text-center">
      <SEO title="Page Not Found" />
      <p className="font-serif text-7xl font-light text-gold">404</p>
      <h1 className="mt-4 font-serif text-3xl font-light text-ink">This page has wandered off</h1>
      <p className="mt-3 text-sm text-muted-foreground">The page you're looking for doesn't exist or has been moved.</p>
      <Link to="/" className="mt-8 bg-ink px-10 py-4 text-[11px] uppercase tracking-[0.2em] text-ivory hover:bg-gold">
        Back to Home
      </Link>
    </div>
  );
}
